export class Token {
    Expires: Date;
    Issued: Date;
    AccessToken: string;
    ExpiresIn: number;
    TokenType: string;
    Username: string;
    UserID: string;
    RoleName: string;

    Deserialize(input: any): Token{
        this.Expires = input['.expires'];
        this.Issued = input['.issued'];
        this.AccessToken = input.access_token;
        this.ExpiresIn = input.expires_in;
        this.TokenType = input.token_type;
        this.Username = input.userName;
        this.UserID = input.userID;
        this.RoleName = input.roleName;

        return this;
    }
}
